module.exports = __webpack_public_path__ + "img/5.983dfc23.jpg";